// Minimal markdown renderer (headings, bold, lists, paragraphs)
export function Markdown({ text = "" }) {
  const lines = text.replace(/\r/g, "").split("\n");
  const blocks = [];
  let list = [];

  const flushList = (key) => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${key}`} className="my-4 ml-5 list-disc space-y-2 text-slate-700">
          {list.map((it, i) => (
            <li key={i}>{inline(it)}</li>
          ))}
        </ul>
      );
      list = [];
    }
  };

  const inline = (s) =>
    s.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
      part.startsWith("**") && part.endsWith("**") ? (
        <strong key={i} className="font-semibold text-slate-900">
          {part.slice(2, -2)}
        </strong>
      ) : (
        part
      )
    );

  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    if (line.startsWith("### ")) {
      flushList(idx);
      blocks.push(<h3 key={idx} className="mt-6 mb-2 text-xl font-semibold text-[#263871]">{inline(line.slice(4))}</h3>);
    } else if (line.startsWith("## ")) {
      flushList(idx);
      blocks.push(<h2 key={idx} className="mt-8 mb-3 text-2xl font-bold text-[#263871]">{inline(line.slice(3))}</h2>);
    } else if (line.startsWith("# ")) {
      flushList(idx);
      blocks.push(<h1 key={idx} className="mt-8 mb-3 text-3xl font-bold text-[#263871]">{inline(line.slice(2))}</h1>);
    } else if (line.startsWith("- ") || line.startsWith("* ")) {
      list.push(line.slice(2));
    } else if (line.trim() === "") {
      flushList(idx);
    } else {
      flushList(idx);
      blocks.push(<p key={idx} className="my-3 leading-relaxed text-slate-700">{inline(line)}</p>);
    }
  });
  flushList("end");
  return <div>{blocks}</div>;
}
